import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row>
          <Col className="text-center p-5">
            See something wrong or unclear? Got any ideas? Help{' '}
            <a href="https://github.com/karishmashuklaa/chic-ui">Chic UI </a> 
            get better by contributing{' '}
            <a href="https://github.com/karishmashuklaa/chic-ui">here!</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
